import React from 'react';
import type ProformaJiraDataConnectionsPage from '@atlassian/jira-spa-apps-admin-pages-proforma-data-connections/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProformaJiraDataConnectionsPage = lazyForPaint<
	typeof ProformaJiraDataConnectionsPage
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-forms-data-connections", jiraSpaEntry: "async-admin-pages-issue-types-directory" */ '@atlassian/jira-spa-apps-admin-pages-proforma-data-connections'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProformaJiraDataConnectionsPage}
		pageId="jira-admin-pages-forms-data-connections"
		shouldShowSpinner
	/>
);
